import './main.less';
import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm, Field } from 'redux-form';

import SelectField from '../../../shared/form-elements/select/field';
import InputField from '../../../shared/form-elements/input';
import TextField from '../../../shared/form-elements/textarea';
import Attachment from '../../../shared/form-elements/attachment';
import ModalBox from '../../../shared/modal';

const Form = props =>
	<div className="thread-create__wrap">
		<form action="" className="ui-form" onSubmit={props.handleSubmit(data => props.formSubmit(data))}>
			<div className="ui-form__element">
				<Field name="title" placeholder={props.intl('Title')} component={InputField} />
			</div>
			<div className="ui-form__element">
				<Field
					name="priority"
					placeholder={props.intl('Priority')}
					component={SelectField}
					searchable={false}
					clearable={false}
					options={props.priorities}
				/>
			</div>

			<div className="ui-form__element">
				<Field
					name="affiliate_id"
					placeholder={props.intl('Affiliate')}
					component={SelectField}
					searchable={true}
					multi={true}
					options={props.affiliatesLookup}
					disabled={
						props.createThreadFormDisabledFields && props.createThreadFormDisabledFields.indexOf('affiliate_id') !== -1
					}
				/>
			</div>
			<div className="ui-form__element">
				<Field name="text" placeholder={props.intl('Text')} component={TextField} />
			</div>
			<div className="ui-form__element buttons-wrap">
				<button className="ui-btn ui-btn-primary">
					{props.intl('Save')}
				</button>
				<div className="attachment">
					<Field
						name="files"
						component={Attachment}
						placeholder={props.intl('Attach files')}
						preparationFile={props.preparationFile}
					/>

					<div className="attachment__list">
						{props.attachmentsInfo &&
							props.attachmentsInfo.map((fileName, index) =>
								<p key={index} className="file-info">
									{fileName}
									<span
										className="icon-delete"
										onClick={e => {
											confirm(props.intl('Remove attachment?')) && props.removeFile(index);
										}}
									/>
								</p>
							)}
					</div>
				</div>
			</div>
		</form>
	</div>;

const Main = props =>
	<ModalBox
		title={props.intl('Create threads')}
		body={Form(props)}
		isOpen={props.shouldShowCreateThreadForm}
		onClose={props.toggleCreateThreadForm}
		className="create-threads-modal"
	/>;

Form.propTypes = {
	intl: PropTypes.func,
	handleSubmit: PropTypes.func,
	formSubmit: PropTypes.func,
	priorities: PropTypes.array,
	affiliatesLookup: PropTypes.func,
	preparationFile: PropTypes.func,
	attachmentsInfo: PropTypes.array,
	createThreadFormDisabledFields: PropTypes.array
};

Main.propTypes = {
	intl: PropTypes.func,
	shouldShowCreateThreadForm: PropTypes.bool,
	toggleCreateThreadForm: PropTypes.func
};

export default formName =>
	reduxForm({
		form: formName
	})(Main);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/threads/components/create-form/main.js